import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { CheckCircle2, ExternalLink } from "lucide-react";

const RAZORPAY_PAGE = process.env.REACT_APP_RAZORPAY_PAYMENT_URL;
const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export default function OrderSuccess() {
  const { id } = useParams();
  const location = useLocation();
  const [order, setOrder] = useState(location.state || null);

  useEffect(() => {
    if (order) return;
    try {
      const stashed = sessionStorage.getItem("arisha_last_order");
      if (stashed) {
        const parsed = JSON.parse(stashed);
        if (parsed?.id === id) setOrder(parsed);
      }
    } catch (err) { /* ignore */ }
  }, [id, order]);

  const waLink = order
    ? `https://wa.me/919769128394?text=${encodeURIComponent(`Hi Arisha Creations, I placed order ${order.id} for ${money(order.total)}. Sharing my payment confirmation.`)}`
    : `https://wa.me/919769128394`;

  const payUrl = order && RAZORPAY_PAGE ? `${RAZORPAY_PAGE}?amount=${order.total}` : RAZORPAY_PAGE;
  const awaiting = order?.payment_status === "awaiting_payment";

  return (
    <div className="success-page" data-testid="order-success-page">
      <div className="success-card">
        <CheckCircle2 size={44} className="success-icon" aria-hidden="true" />
        <span className="lux-eyebrow">Order placed</span>
        <h1>Thank you{order?.customer?.name ? `, ${order.customer.name.split(" ")[0]}` : ""}.</h1>
        {awaiting
          ? <p>Your order is reserved. Please complete payment on the Razorpay page to confirm — we&apos;ll reach you on {order?.customer?.mobile} once it arrives.</p>
          : <p>Your order is being prepared with care. We&apos;ll reach you on {order?.customer?.mobile}.</p>}
        <div className="order-ref">Order reference<strong data-testid="order-reference">{order?.id || id}</strong></div>

        {awaiting && payUrl && (
          <a className="lux-cta full pay-cta" href={payUrl} target="_blank" rel="noreferrer" data-testid="pay-now-button">
            Pay {money(order.total)} on Razorpay <ExternalLink size={15} />
          </a>
        )}

        <a className="whatsapp-button" href={waLink} target="_blank" rel="noreferrer" data-testid="whatsapp-share-button">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.52 3.48A11.86 11.86 0 0 0 12.05 0C5.5 0 .18 5.32.18 11.87c0 2.09.55 4.13 1.59 5.93L0 24l6.36-1.66a11.85 11.85 0 0 0 5.69 1.45h.01c6.55 0 11.87-5.32 11.87-11.87 0-3.17-1.24-6.15-3.41-8.44Zm-8.47 18.24h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.77.99 1.01-3.67-.24-.38a9.85 9.85 0 0 1-1.51-5.2c0-5.45 4.43-9.88 9.88-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.9 6.98c0 5.45-4.43 9.87-9.86 9.87Zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.87 1.22 3.07.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35Z" /></svg>
          WhatsApp us with payment proof
        </a>

        <Link to="/shop" className="lux-text-link centered" data-testid="continue-shopping-button">Continue shopping</Link>
        <Link to="/track" className="lux-text-link centered" data-testid="track-order-link" style={{marginTop:"4px"}}>Track this order later ↗</Link>
      </div>
    </div>
  );
}
